// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__xexDY","header":"Layout_header__Lvkev","body":"Layout_body__qXXT+","footer":"Layout_footer__X5yQb"};